// src/tabs/agencyEdit/AgencySolicitorsTab.jsx

import React from 'react';
import useRequireAuth from '../../hooks/useRequireAuth';

const AgencySolicitorsEditTab = ({
  solicitorForm,
  handleChange,
  handleStatusButtonClick,
  handleEdit,
  onReturn
}) => {

  const userInfo = useRequireAuth();

  // 日付のみを表示する関数（YYYY/MM/DD形式に変換）
  const formatDateForDisplay = (dateTimeString) => {
    if (!dateTimeString) return '';
    let datePart = '';
    if (dateTimeString.includes('T')) {
      datePart = dateTimeString.split('T')[0];
    } else {
      datePart = dateTimeString;
    }
    // スラッシュ形式をハイフン形式に変換（input[type="date"]用）
    if (datePart.includes('/')) {
      return datePart.replace(/\//g, '-');
    }
    return datePart;
  };

  return (
    <div className="solicitor-container c-max-large">
      {/* 募集人登録フォーム */}
      <div className="solicitor-registration-section c-max-middle">
        {/* ステータスの表示部分 */}
        <div className="status-display">
          <span className="status-label">現在の利用状況</span>
          <div className="c-checkbox-inner c-max-m-small">
            <button
              className={`btn-confirm-mini c-max-x-small ${solicitorForm.isActive == true ? '' : 'white'}`}
              onClick={() => handleStatusButtonClick(true)}
            >
              利用中
            </button>
            <button
              className={`btn-confirm-mini c-max-x-small ${solicitorForm.isActive == false ? '' : 'white'}`}
              onClick={() => handleStatusButtonClick(false)}
            >
              停止中
            </button>
          </div>
        </div>

        <table className="info-table c-max-middle">
          <tbody>
            <tr>
              <th>支店名</th>
              <td colSpan="3">
                <input
                  className="form-input"
                  type="text"
                  name="branchName"
                  value={solicitorForm.branchName}
                  onChange={handleChange}
                  required
                />
              </td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td colSpan="3">
                <input
                  className="form-input"
                  type="email"
                  name="accountname"
                  value={solicitorForm.accountname}
                  onChange={handleChange}
                  required
                />
              </td>
            </tr>
            <tr>
              <th>担当者名漢字</th>
              <td>
                <input
                  className="form-input"
                  type="text"
                  name="name"
                  value={solicitorForm.name}
                  onChange={handleChange}
                  required
                />
              </td>
              <th>担当者カナ</th>
              <td>
                <input
                  className="form-input"
                  type="text"
                  name="nameKana"
                  value={solicitorForm.nameKana}
                  onChange={handleChange}
                />
              </td>
            </tr>
          {(!userInfo.is_agent || userInfo.is_admin) && (
            <tr>
              <th>利用開始日</th>
              <td>
                <input
                  className="form-input"
                  type="date"
                  max="9999-12-31"
                  name="startDate"
                  value={formatDateForDisplay(solicitorForm.startDate)}
                  onChange={handleChange}
                  required
                />
              </td>
              <th>利用終了日</th>
              <td>
                <input
                  className="form-input"
                  type="date"
                  max="9999-12-31"
                  name="endDate"
                  value={formatDateForDisplay(solicitorForm.endDate)}
                  onChange={handleChange}
                />
              </td>
            </tr>
          )}
          <tr>
              <th>プロフィール</th>
              <td colSpan="3">
                <textarea
                  className="form-textarea"
                  name="profile"
                  value={solicitorForm.profile}
                  onChange={handleChange}
                  rows="4"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="action-buttons c-max-mini c-m-center">
        <button
          type="button"
          className="button button-secondary button-medium"
          onClick={onReturn}
        >
          戻る
        </button>
        <button
          className="btn btn-primary button-medium"
          onClick={handleEdit}
        >
          変更を保存する
        </button>
      </div>
    </div>
  );
};

export default AgencySolicitorsEditTab;
